module.exports = __webpack_public_path__ + "static/media/proj2.063ccb57.png";